import { capitalizeWords } from './helper-functions.utils';

/** Minimální tvar osoby pro zobrazení jména – vyhovuje OsobaVysledekDto, UzivatelIODto i ručním objektům. */
export interface OsobaJmeno {
  nazev?: string | null;
  jmeno?: string | null;
  prijmeni?: string | null;
}

/**
 * Zobrazované jméno osoby: název (PO), jinak „Jméno Příjmení“ s normalizovanou velikostí písmen.
 * Chybějící části vynechá; bez údajů vrátí prázdný řetězec. Stejnou logiku používá pipe `displayOsoba`.
 */
export function formatOsoba(osoba: OsobaJmeno | null | undefined): string {
  if (!osoba) return '';
  if (osoba.nazev) return osoba.nazev;
  return [osoba.jmeno, osoba.prijmeni]
    .filter((x): x is string => !!x)
    .map((val) => capitalizeWords(val))
    .join(' ');
}
